// page/auth/admin/api/endpoints.js
const BASE = process.env.REACT_APP_API_REAL_URL;

export const API = {
    base: BASE,

    auth: {
        verify: `${BASE}/auth/verify`,
        verifyAdmin: `${BASE}/auth/verify_admin`,
        logout: `${BASE}/auth/logout`,
    },

    employees: {
        list: `${BASE}/api/employees/list`,
        create: `${BASE}/api/employees/create`,
        /** 로그인 ID 중복 확인 — ?email=ksw[&excludeEmployeeCode=E0001] */
        checkLoginId: `${BASE}/api/employees/exists`,
        update: (employeeCode) => `${BASE}/api/employees/update/${employeeCode}`,
        delete: (employeeCode) => `${BASE}/api/employees/delete/${employeeCode}`,
        resetPassword: (employeeCode) => `${BASE}/api/employees/reset_password/${employeeCode}`,
        setPassword: (employeeCode) => `${BASE}/api/employees/set_password/${employeeCode}`,

        changePassword: `${BASE}/api/employees/change_password`,
        myKeywordsGet: `${BASE}/api/employees/me/keywords`,
        myKeywordsSave: `${BASE}/api/employees/me/keywords`,
        me: `${BASE}/api/employees/me`,
    },

    positions: {
        list: `${BASE}/api/positions/list`,
        create: `${BASE}/api/positions/create`,
        update: (positionId) => `${BASE}/api/positions/update/${positionId}`,
        delete: (positionId) => `${BASE}/api/positions/delete/${positionId}`,
    },

    duties: {
        list: `${BASE}/api/duties/list`,
        create: `${BASE}/api/duties/create`,
        update: (dutyId) => `${BASE}/api/duties/update/${dutyId}`,
        delete: (dutyId) => `${BASE}/api/duties/delete/${dutyId}`,
    },

    departments: {
        list: `${BASE}/api/departments/list`,
        create: `${BASE}/api/departments/create`,
        update: (deptId) => `${BASE}/api/departments/update/${deptId}`,
        delete: (deptId) => `${BASE}/api/departments/delete/${deptId}`,
    },

    permissions: {
        listDb: `${BASE}/api/permissions`,
    },

    adminPermissions: {
        listAll: `${BASE}/api/permissions/list`,

        employeeGet: (employeeCode) => `${BASE}/api/permissions/employee/${employeeCode}`,
        employeeReplace: (employeeCode) => `${BASE}/api/permissions/employee/${employeeCode}`,

        deptGet: (deptId) => `${BASE}/api/permissions/department/${deptId}`,
        deptReplace: (deptId) => `${BASE}/api/permissions/department/${deptId}`,

        effective: (employeeCode) => `${BASE}/api/permissions/effective/${employeeCode}`,
        allEmployees: `${BASE}/api/permissions/employees`,
        allDepts: `${BASE}/api/permissions/departments`,
    },
};
